
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQSection from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';
function Tempotravellerhireforoutstation() {



    const cardData =
    {
        keyword: ' Tempo Traveller Hire for Outstation in Pune',
        heading: 'Samarth Travels:  Tempo Traveller Hire for Outstation in Pune',
        headingDescription: 'Samarth Travels offers Tempo Traveller hire for outstation in Pune, perfect for family vacations, group tours, pilgrimages, and weekend getaways. Our spacious Tempo Travellers are equipped with air-conditioning, push-back seats, and ample legroom to ensure a smooth and comfortable journey over long distances. With courteous drivers, transparent fares, and dependable service, Samarth Travels guarantees a stress-free and enjoyable outstation travel experience.',

        top: 'Top Places to Visit in Pune Outstation with Samarth Travels',

      "topPlaces": [
    {
      "title": "Mahabaleshwar",
      "description": "Nestled in the Western Ghats, Mahabaleshwar is a scenic hill station around 120 km from Pune. Known for its lush strawberry farms, panoramic viewpoints like Arthur’s Seat and Wilson Point, and the historic Mahabaleshwar Temple, it offers a cool and refreshing retreat. Boating on Venna Lake and walking through misty trails make it a perfect weekend getaway."
    },
    {
      "title": "Lonavala & Khandala",
      "description": "Just about 65 km from Pune, the twin hill stations of Lonavala and Khandala are famous for their lush valleys, waterfalls, and forts like Rajmachi and Lohagad. The monsoon season enhances their charm, drawing travelers for trekking, picnics, and chikki shopping. Bhushi Dam and Tiger’s Leap are must-visit attractions in this green paradise."
    },
    {
      "title": "Shirdi",
      "description": "Located approximately 200 km from Pune, Shirdi is a revered pilgrimage town dedicated to Sai Baba. The Sai Baba Temple complex attracts millions of devotees each year. Besides the temple, other spots like Dwarkamai, Chavadi, and the Sai Heritage Village offer spiritual solace and insights into the saint’s life and teachings."
    },
    {
      "title": "Lavasa",
      "description": "Lavasa is a planned hill city about 60 km from Pune, offering Italian-style architecture and lakeside promenades. Popular for romantic getaways and weekend breaks, Lavasa features adventure sports, nature trails, and serene boat rides on the Warasgaon Lake. Its colorful buildings and vibrant cafes make it a photogenic escape."
    },
    {
      "title": "Alibaug",
      "description": "Alibaug is a coastal town around 140 km from Pune, known for its clean beaches and colonial forts. With attractions like Alibaug Beach, Kolaba Fort, and Mandwa Beach, it's a great destination for beach lovers. It’s ideal for water sports, seafood cuisine, and short family trips by road or ferry from Mumbai."
    },
    {
      "title": "Nashik",
      "description": "About 210 km from Pune, Nashik is a blend of spirituality and wine tourism. It’s home to the sacred Godavari River, Trimbakeshwar Temple, and Muktidham, making it a major religious center. Simultaneously, vineyards like Sula and York offer wine tasting and stunning vineyard views, making it a unique dual-experience destination."
    },
    {
      "title": "Kolhapur",
      "description": "Located 230 km from Pune, Kolhapur is rich in heritage, known for the Mahalaxmi Temple, New Palace Museum, and rankala Lake. It’s also famed for its spicy cuisine and handcrafted Kolhapuri chappals. A perfect cultural and culinary escape, Kolhapur provides a deep dive into Maharashtrian traditions."
    },
    {
      "title": "Bhimashankar",
      "description": "Approximately 110 km from Pune, Bhimashankar is a sacred Jyotirlinga shrine nestled in dense forests of the Sahyadri hills. Ideal for spiritual seekers and nature lovers, the region also forms part of a wildlife sanctuary. Trekking trails, misty landscapes, and temple architecture make it a soul-soothing destination."
    },
    {
      "title": "Matheran",
      "description": "Located about 120 km from Pune, Matheran is Asia’s only automobile-free hill station. Famous for its red-soiled paths, vintage toy train, and viewpoints like Panorama Point and Echo Point, it’s a tranquil retreat amidst nature. Horse rides and eco-friendly travel make it a unique experience."
    },
    {
      "title": "Goa",
      "description": "Though around 450 km away, Goa is a top outstation pick from Pune for those seeking beaches, nightlife, and Portuguese charm. From serene South Goa beaches like Palolem to lively North Goa spots like Baga and Anjuna, it’s perfect for parties, watersports, and cultural explorations. The drive or train journey adds to the adventure."
    }
  ],

"services": [
    {
        "name": "Pune to Outstation Tempo Traveller",
        "description": "Rent a Tempo Traveller for your next outstation trip from Pune with Samarth Travels. Whether you're heading to nearby cities or long-distance destinations, our well-maintained Tempo Travellers provide a comfortable and spacious journey for your group, ensuring a smooth and enjoyable ride."
    },
    {
        "name": "Tempo Traveller Pune Rent",
        "description": "Looking to rent a Tempo Traveller in Pune? Samarth Travels offers flexible rental services, allowing you to choose the best vehicle for your needs. Whether it's for a local trip, a family outing, or a corporate event, we ensure top-notch service and a comfortable journey."
    },
    {
        "name": "Pune Tempo Traveller Hire for Outstation",
        "description": "Planning an outstation trip from Pune? Hire a Tempo Traveller from Samarth Travels for a hassle-free experience. Our fleet of well-maintained vehicles is perfect for long-distance travel, offering ample space and comfort for your group, family, or corporate outing."
    },
    {
        "name": "Pune to Outstation Tempo Traveller",
        "description": "Rent a Tempo Traveller for an outstation journey from Pune with Samarth Travels. Whether it’s a weekend getaway or a business trip, our Tempo Travellers are equipped with modern amenities to ensure your comfort throughout the ride."
    },
    {
        "name": "Pune to Goa Tempo Traveller",
        "description": "Travelling from Pune to Goa? Rent a Tempo Traveller for a comfortable and scenic journey. Our vehicles are perfect for group travel, with ample space for luggage and a smooth, air-conditioned ride to your destination, ensuring you arrive refreshed and relaxed."
    },
    {
        "name": "Pune to Kolhapur Tempo Traveller Rent",
        "description": "Head to Kolhapur from Pune in comfort by renting a Tempo Traveller from Samarth Travels. Ideal for family trips, group outings, or corporate travel, our vehicles provide the perfect combination of space and luxury, making your trip to Kolhapur both comfortable and memorable."
    },
    {
        "name": "Pune Tempo Traveller Hire for Outstation",
        "description": "Hire a Tempo Traveller for your outstation travel from Pune with Samarth Travels. Whether it's a short trip to a nearby destination or a long-distance journey, our vehicles provide the perfect solution for group travel, offering comfort and reliability for your trip."
    },
    {
        "name": "Pune to Nashik Tempo Traveller Rent",
        "description": "Rent a Tempo Traveller from Pune to Nashik for a comfortable and enjoyable journey. Whether you’re going for a religious visit or a sightseeing tour, our Tempo Travellers offer ample space and modern amenities for a smooth ride to Nashik."
    },
    {
        "name": "Pune to Mumbai Tempo Traveller Rent",
        "description": "Travelling from Pune to Mumbai? Rent a Tempo Traveller from Samarth Travels for your journey. Our vehicles are ideal for group travel, providing plenty of space and a comfortable ride, whether it’s for business or leisure."
    },
    {
        "name": "Pune to Pandharpur Tempo Traveller Fare",
        "description": "Samarth Travels offers competitive fares for Tempo Traveller rentals to Pandharpur from Pune. Whether you’re going for a religious visit or a group outing, we provide a comfortable and cost-effective travel solution with spacious seating and air-conditioning."
    },
    {
        "name": "Pune Mumbai Airport Drop Tempo Traveller on Rent",
        "description": "For airport transfers from Pune to Mumbai, rent a Tempo Traveller with Samarth Travels. We provide reliable and timely service, ensuring your group or family travels comfortably and arrives at the airport on time, whether it's for a flight or an airport pickup."
    },
    {
        "name": "Tempo Traveller on Rent for Wedding in Pune",
        "description": "Make your wedding transportation easy and luxurious by renting a Tempo Traveller from Samarth Travels. Ideal for transporting guests to wedding venues, our vehicles provide ample seating, air-conditioning, and a comfortable ride to ensure your special day is perfect."
    },
    {
        "name": "17 Seater Tempo Traveller for Outstation in Pune",
        "description": "For larger groups traveling outstation from Pune, rent a 17-seater Tempo Traveller from Samarth Travels. Perfect for family gatherings, corporate outings, or group trips, this vehicle ensures a comfortable and spacious ride, complete with modern amenities."
    },
    {
        "name": "Luxury Tempo Traveller on Rent in Pune",
        "description": "For a premium travel experience, rent a luxury Tempo Traveller in Pune. Our luxury Tempo Travellers are equipped with plush interiors, air-conditioning, and comfortable seating, offering a first-class ride for your group, whether it’s for an outstation trip or a special occasion."
    },
    {
        "name": "Outstation Tempo Traveller for Picnic on Rent in Pune",
        "description": "Planning a picnic with friends or family? Rent an outstation Tempo Traveller from Samarth Travels for your trip. Our vehicles offer ample space for picnic supplies, luggage, and group seating, ensuring a comfortable and enjoyable ride to your picnic destination."
    },
    {
        "name": "Tempo Traveller on Rent for Outstation",
        "description": "Rent a Tempo Traveller for your outstation travel from Pune. Whether it's a long-distance journey or a weekend getaway, our vehicles are well-suited for group travel, offering comfort, air-conditioning, and a smooth ride for all passengers."
    }
],
"tableData": [
    ["Pune to Outstation Tempo Traveller", "Tempo Traveller Pune Rent"],
    ["Pune Tempo Traveller Hire for Outstation", "Pune to Outstation Tempo Traveller"],
    ["Pune to Goa Tempo Traveller", "Pune to Kolhapur Tempo Traveller Rent"],
    ["Pune Tempo Traveller Hire for Outstation", "Pune to Nashik Tempo Traveller Rent"],
    ["Pune to Mumbai Tempo Traveller Rent", "Pune to Pandharpur Tempo Traveller Fare"],
    ["Pune Mumbai Airport Drop Tempo Traveller on Rent", "Tempo Traveller on Rent for Wedding in Pune"],
    ["17 Seater Tempo Traveller for Outstation in Pune", "Luxury Tempo Traveller on Rent in Pune"],
    ["Outstation Tempo Traveller for Picnic on Rent in Pune", "Tempo Traveller on Rent for Outstation"]
],


"whychoose": [
    {
        "WhyChooseheading": "Reliable Tempo Traveller Hire for Outstation Travel from Pune",
        "WhyChoosedescription": "We provide trusted Tempo Traveller rental services for outstation trips from Pune. Whether you're traveling for a family vacation, a corporate retreat, or a group tour, our Tempo Travellers ensure a comfortable, timely, and hassle-free journey with experienced drivers."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable Tempo Travellers for Long-Distance Travel",
        "WhyChoosedescription": "Our Tempo Travellers offer ample space and comfort for your outstation trips. With seating for up to 12-17 passengers, air-conditioning, comfortable seats, and plenty of legroom, your group will enjoy a relaxing and pleasant journey over long distances."
    },
    {
        "WhyChooseheading": "Professional Drivers for Safe and Efficient Travel",
        "WhyChoosedescription": "Our professional and experienced drivers are familiar with outstation routes, ensuring a smooth, safe, and punctual journey. They prioritize passenger comfort and safety, making sure you arrive at your destination on time and without any issues."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing for Outstation Rentals",
        "WhyChoosedescription": "We offer competitive and transparent pricing for Tempo Traveller outstation rentals, with no hidden charges. Whether you need a van for a few hours or a multi-day trip, we provide flexible and budget-friendly packages to suit your travel needs."
    },
    {
        "WhyChooseheading": "24/7 Availability for Flexible Outstation Scheduling",
        "WhyChoosedescription": "Our Tempo Traveller services are available 24/7, allowing you to schedule your outstation trip at any time. Whether you're planning an early morning departure or a late-night return, we ensure that your travel plans are met without any delays."
    },
    {
        "WhyChooseheading": "Easy Booking and Real-Time Updates for Smooth Coordination",
        "WhyChoosedescription": "Booking your Tempo Traveller for outstation travel from Pune is simple and quick. Once confirmed, you will receive real-time tracking information, driver contact details, and van arrival updates, ensuring smooth coordination and peace of mind throughout the trip."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Tempo Travellers for Your Safety",
        "WhyChoosedescription": "We ensure that all our Tempo Travellers are regularly maintained, thoroughly cleaned, and sanitized before each trip, providing a hygienic and comfortable environment for passengers throughout the outstation journey."
    },
    {
        "WhyChooseheading": "Multiple Payment Options for Convenient Booking",
        "WhyChoosedescription": "We provide a variety of payment methods, including UPI, credit/debit cards, digital wallets, and cash, allowing you to conveniently complete your Tempo Traveller booking securely."
    }
]

























    }

const faqData = [
    {
        id: 1,
        question: 'How can I hire a Tempo Traveller for an outstation trip from Pune?',
        answer: 'Hiring a Tempo Traveller for your outstation trip from Pune is easy with Samarth Travels. You can book through our website or by calling our customer support. Just provide your travel details, such as the destination, travel dates, number of passengers, and we will arrange the perfect vehicle for your trip.',
    },
    {
        id: 2,
        question: 'What types of Tempo Travellers are available for outstation trips from Pune?',
        answer: 'We offer various sizes of Tempo Travellers for outstation trips, including 12-seater, 15-seater, and 17-seater vehicles. All are well-maintained, equipped with comfortable seating, air conditioning, and ample luggage space, ideal for group trips to nearby or distant destinations.',
    },
    {
        id: 3,
        question: 'What are the rental charges for Tempo Travellers for outstation trips from Pune?',
        answer: 'Rental charges for Tempo Travellers for outstation trips start from ₹30/km, depending on the size of the vehicle and the distance traveled. We also offer all-inclusive packages based on your travel duration and specific trip requirements.',
    },
    {
        id: 4,
        question: 'Is the Tempo Traveller suitable for long-distance or multi-day outstation trips?',
        answer: 'Yes, the Tempo Traveller is perfect for long-distance or multi-day trips. It provides a smooth and comfortable ride with reclining seats, AC, and ample legroom, making it ideal for extended journeys or multi-day tours with family, friends, or colleagues.',
    },
    {
        id: 5,
        question: 'Can I customize the pickup and drop-off locations for my outstation Tempo Traveller rental?',
        answer: 'Absolutely! We allow you to customize your pickup and drop-off locations according to your travel plans. Whether you need to be picked up from Pune or specific locations, we can accommodate your itinerary to ensure a seamless travel experience.',
    },
    {
        id: 6,
        question: 'Does the Tempo Traveller rental include a driver and fuel?',
        answer: 'Yes, all Tempo Traveller rentals include a professional driver and fuel. Any additional charges, such as tolls, parking fees, or permits, will be communicated upfront for complete transparency.',
    },
    {
        id: 7,
        question: 'Is 24/7 customer support available for Tempo Traveller bookings?',
        answer: 'Yes, Samarth Travels offers 24/7 customer support for all Tempo Traveller bookings. Whether you need assistance with booking or any changes to your travel plans, our team is available to help you anytime.',
    },
];

const testimonials = [
    {
        name: 'Mr. Raghav Deshmukh',
        role: 'Travel Group Organizer',
        text: 'We hired a 15-seater Tempo Traveller for an outstation trip from Pune to Goa. The vehicle was clean, comfortable, and well-maintained. The driver was friendly and ensured a smooth journey. I highly recommend Samarth Travels for group trips.',
        image: '/img/testimonial/testi_tempo_raghav.jpg',
    },
    {
        name: 'Ms. Aishwarya Rathi',
        role: 'Family Trip Planner',
        text: 'Booked a 12-seater Tempo Traveller for a family trip to Mahabaleshwar. The vehicle was spacious, with great air conditioning and enough luggage space for everyone. Samarth Travels made our trip incredibly comfortable and stress-free.',
        image: '/img/testimonial/testi_tempo_aishwarya.jpg',
    },
];


































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9860256019",
            "+91 9527500025",

        ],
        email: "samarthtravels9119@gmail.com"
    };


   const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: " Tempo Traveller Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Tempo Traveller on Rent Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: " Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: " Tempo Traveller on Rent",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Tempo Traveller Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Tempo Traveller Hire in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: " Mini Bus for Rent",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Bus on Rent Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: " Bus on Rent Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: " Bus Rental in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: " Hire Tempo Traveller",
        },
        {
            place: "/images/keyword/12.jpg",
            text: " Bus Hire in Pune",
        },
        {
            place: "/images/keyword/13.jpg",
            text: " Ac Tempo Traveller Rent Pune",
        },
        {
            place: "/images/keyword/14.jpg",
            text: " Bus Hire For Outstation",
        },
        {
            place: "/images/keyword/15.jpg",
            text: " Bus on Rent for Local",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Bus Rental For Wedding",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Bus Rent for Marriage",
        },
        {
            place: "/images/keyword/18.jpg",
            text: " Bus Rental For Corporate Events",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "  Bus Rental for Tour",
        },

        {
            place: "/images/keyword/20.jpg",
            text: "Bus Rental For Corporate in Pune",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/22.jpg",
            text: " AC Bus On Rent",
        },
        {
            place: "/images/keyword/23.jpg",
            text: " Non Ac Bus Rental Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Bus on Hire on Pune to Mahabaleshwar Package Tour ",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Bus Hire for Picnic",
        },
    ];


    const images = [
        { src: "/images/fleets/1.jpg", alt: "Image 1" },
        { src: "/images/fleets/2.jpg", alt: "Image 1" },
        { src: "/images/fleets/3.jpg", alt: "Image 1" },
        { src: "/images/fleets/4.jpg", alt: "Image 1" },
        { src: "/images/fleets/5.jpg", alt: "Image 1" },
        { src: "/images/fleets/6.jpg", alt: "Image 1" },
        { src: "/images/fleets/7.jpg", alt: "Image 1" },
        { src: "/images/fleets/8.jpg", alt: "Image 1" },
        { src: "/images/fleets/9.jpg", alt: "Image 1" },


    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Tempo Traveller Hire for Outstation in Pune",
  "image": "https://samarthtravels.com/assets/images/tempo-traveller-hire-outstation-pune.jpg",
  "description": "Rent a Tempo Traveller for outstation trips from Pune, including travel to Goa, Kolhapur, Nashik, Mumbai, Pandharpur, and more. Affordable and luxury options available for group travel, family outings, corporate trips, and weddings.",
  "brand": {
    "@type": "Brand",
    "name": "Samarth Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4000",
    "availability": "https://schema.org/InStock",
    "url": "https://samarthtravels.com/tempo-traveller-hire-outstation-pune"
  }
};




    return (
        <div>


<Helmet>
  <title>Tempo Traveller Hire for Outstation in Pune | Rent for Goa, Mumbai, Kolhapur & More | Samarth Travels</title>
  <meta 
    name="description" 
    content="Rent Tempo Traveller for outstation trips from Pune, including destinations like Goa, Mumbai, Kolhapur, Nashik & Pandharpur. Luxury and affordable options for group travel and weddings." 
  />
  <meta 
    name="keywords" 
    content="Pune to Outstation Tempo Traveller, Tempo Traveller Pune rent, Pune tempo traveller hire for outstation, Pune to Goa Tempo Traveller, Pune to Kolhapur Tempo Traveller rent, Pune tempo traveller hire for outstation, Pune to Nashik tempo traveller rent, Pune to Mumbai tempo traveller rent, Pune to Pandharpur tempo traveller fare, Pune Mumbai Airport Drop Tempo Traveller on Rent, Tempo Traveller On Rent for Wedding in Pune, 17 Seater Tempo Traveller for Outstation in Pune, Luxury tempo traveller on rent in Pune, Outstation tempo traveller for picnic on rent in Pune, Tempo Traveller on rent for Outstation" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <div className="breadcumb-wrapper" data-bg-src="/images/breadcumb-bg.jpg">
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title text-center">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/51.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Samarth Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQSection faqs={faqData} accordionId="drivingAccordion" />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword
                                data={testimonials}
                                title="What Our Clients Are Saying"
                                subtitle="Customer Feedback"
                            />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #FF8F1F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF8F1F' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919860256019" className="d-block  text-white">+91 9860256019</a>
                                                <a href="tel:+919527500025" className="d-block  text-white">+91 9527500025</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:samarthtravels9119@gmail.com" className=" text-white d-block">
                                                    samarthtravels9119@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Samarth Travels <br />
                                                        Flat no 201, Juhi Building, Suyash Shrushti Society, Tukai darshan Hadapsar, Pune- 411028
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Tempotravellerhireforoutstation;